// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0ffb98b8","453":"64ee9129","455":"0b016420","977":"9aeb1ec2"}[chunkId] + ".chunk.js";
};